module.exports = __webpack_public_path__ + "static/media/postgresql.9400e9de.png";